import { CalculatorState, CalculatorSummary } from './state';

import { ReferenceDataItem } from './state';

export enum ActionType {
    PageLoaded = 'Calculator/PageLoaded',
    UpdateAge = 'Calculator/UpdateAge',
    UpdateStudentAgeDob = 'Calculator/UpdateStudentAgeDob',
    UpdateAgent = 'Calculator/UpdateAgent',
    UpdateAgentType = 'Calculator/UpdateAgentType',
    UpdateCountryOfResidence = 'Calculator/UpdateCountryOfResidence',
    UpdateDestinationCountry = 'Calculator/UpdateDestinationCountry',
    UpdateBookingCreationDate = 'Calculator/UpdateBookingCreationDate',
    UpdateCurrency = 'Calculator/UpdateCurrency',
    UpdateDateFrom = 'Calculator/UpdateDateFrom',
    UpdateCentre = 'Calculator/UpdateCentre',
    UpdateWeeks = 'Calculator/UpdateWeeks',
    UpdateSchool = 'Calculator/UpdateSchool',
    UpdateDateTo = 'Calculator/UpdateDateTo',
    UpdateBookingSystem = 'Calculator/UpdateBookingSystem',
    UpdatePromotionCode = 'Calculator/UpdatePromotionCode',
    UpdateDivision = 'Calculator/UpdateDivision',
    SetDivisions = 'Calculator/SetDivisions',
    UpdateSelectedProductType = 'Calculator/UpdateSelectedProductType',
    AddProduct = 'Calculator/AddProduct',
    RemoveProduct = 'Calculator/RemoveProduct',
    UpdateProductDateFrom = 'Calculator/UpdateProductDateFrom',
    UpdateProductDateTo = 'Calculator/UpdateProductDateTo',
    UpdateProductSearchTerm = 'Calculator/UpdateProductSearchTerm',
    UpdateExcludeCommissions = 'Calculator/UpdateExcludeCommissions',
    UpdateEarlyBirds = 'Calculator/UpdateEarlyBirds',
    UpdateMarketDiscount = 'Calculator/UpdateMarketDiscount',
    UpdatePricingScenario = 'Calculator/UpdatePricingScenario',
    UpdateAmendmentDate = 'Calculator/UpdateAmendmentDate',
    UpdatePriceLockToken = 'Calculator/UpdatePriceLockToken',
    SetSummary = 'Calculator/SetSummary',
    SetCalculating = 'Calculator/SetCalculating',
    ReloadReferenceData = 'Calculator/ReloadReferenceData',
    SetReferenceDataLoading = 'Calculator/SetReferenceDataLoading',
    ReloadAgents = 'Calculator/ReloadAgents',
    UpdateAgentOffice = 'Calculator/UpdateAgentOffice',
    LoadAgentOffices = 'Calculator/LoadAgentOffices',
}

export type Action =
    | { type: ActionType.UpdateAge; age?: number }
    | { type: ActionType.UpdateStudentAgeDob; age?: number; dateOfBirth?: string }
    | { type: ActionType.UpdateAgent; agentId?: string }
    | { type: ActionType.UpdateAgentType; agentType: 'Walk In' | 'E-Sale' | 'Agent' }
    | { type: ActionType.UpdateCountryOfResidence; countryId?: string }
    | { type: ActionType.UpdateDestinationCountry; countryId?: string }
    | { type: ActionType.UpdateBookingCreationDate; date?: string }
    | { type: ActionType.UpdateCurrency; currencyId?: string }
    | { type: ActionType.UpdateDateFrom; date?: string }
    | { type: ActionType.UpdateCentre; centreId?: string }
    | { type: ActionType.UpdateWeeks; weeks?: number }
    | { type: ActionType.UpdateSchool; schoolId?: string }
    | { type: ActionType.UpdateDateTo; date?: string }
    | { type: ActionType.UpdateBookingSystem; bookingSystemId?: string }
    | { type: ActionType.UpdatePromotionCode; promotionCode?: string }
    | { type: ActionType.UpdateDivision; divisionId?: string }
    | { type: ActionType.SetDivisions; divisions: ReferenceDataItem[] }
    | { type: ActionType.UpdateSelectedProductType; productType: 'Course' | 'Accommodation' | 'Transfer' | 'Add-ons' | 'Package' }
    | { type: ActionType.AddProduct; product: { id: string; name: string; code?: string; type: 'Course' | 'Accommodation' | 'Transfer' | 'Add-ons' | 'Package'; accommodationType?: 'Residence' | 'Homestay'; accommodationName?: string | null } }
    | { type: ActionType.RemoveProduct; productId: string }
    | { type: ActionType.UpdateProductDateFrom; productId: string; date?: string }
    | { type: ActionType.UpdateProductDateTo; productId: string; date?: string }
    | { type: ActionType.UpdateProductSearchTerm; searchTerm: string }
    | { type: ActionType.UpdateExcludeCommissions; excludeCommissions: boolean }
    | { type: ActionType.UpdateEarlyBirds; earlyBirds: boolean }
    | { type: ActionType.UpdateMarketDiscount; marketDiscount: boolean }
    | {
        type: ActionType.UpdatePricingScenario;
        pricingScenario: 'New booking' | 'Amendment before Arrival' | 'Amendment after Arrival';
      }
    | { type: ActionType.UpdateAmendmentDate; amendmentDate?: string }
    | { type: ActionType.UpdatePriceLockToken; priceLockToken?: string }
    | { type: ActionType.SetSummary; summary?: CalculatorSummary }
    | { type: ActionType.SetCalculating; isCalculating: boolean }
    | { type: ActionType.SetReferenceDataLoading; isLoading: boolean }
    | { 
        type: ActionType.PageLoaded; 
        countries: ReferenceDataItem[];
        currencies: ReferenceDataItem[];
        centres: ReferenceDataItem[];
        schools: ReferenceDataItem[];
        bookingSystems: ReferenceDataItem[];
        agents: ReferenceDataItem[];
      }
    | { 
        type: ActionType.ReloadReferenceData; 
        countries: ReferenceDataItem[];
        currencies: ReferenceDataItem[];
        centres: ReferenceDataItem[];
        schools: ReferenceDataItem[];
      }
    | {
        type: ActionType.ReloadAgents;
        agents: ReferenceDataItem[];
      }
    | { type: ActionType.UpdateAgentOffice; agentOfficeId?: string }
    | { type: ActionType.LoadAgentOffices; agentOffices: ReferenceDataItem[] };